export default function Column({children}){
  return(
    <div className="w-3/12 border-r-[1px] border-slate-300 border-solid mr-2 pr-2">
   {children}
    </div>
  )
}